.horizontal-list-wrapper {
  display: flex;
  margin: 0;
}

.horizontal-list-value {
  align-items: center;
  display: flex;
}

.horizontal-list-separator {
  align-items: center;
  display: flex;
  margin: 0 0.5rem;
}
